export function logout() {
  // If we're inside the VB.NET app and the 'access_token' has expired,
  // we'll need a new one. The code below will force the user to log out
  // and back in again, generating a fresh 'access_token'.

  /* eslint-disable no-undef */
  if (window.location.href.indexOf('aspx') > -1 && __doPostBack) {
    __doPostBack('ctl00$btnSignOut', '');
  }
  /* eslint-enable no-undef */
}



// WEBPACK FOOTER //
// ./src/helpers/logout.js